import { toText, format } from "../fable_modules/fable-library-js.4.17.0/String.js";
import { toFloat64, op_Multiply, toInt64, compare } from "../fable_modules/fable-library-js.4.17.0/BigInt.js";
import { today, date as date_1, compare as compare_1, addYears, addMonths, addDays, now, op_Subtraction, parse, toUniversalTime, toString } from "../fable_modules/fable-library-js.4.17.0/Date.js";
import { totalDays, totalMinutes } from "../fable_modules/fable-library-js.4.17.0/TimeSpan.js";
import { toString as toString_1, Union } from "../fable_modules/fable-library-js.4.17.0/Types.js";
import { class_type, union_type, int32_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";

/**
 * Format large number values to space-seperated thousands presentation
 */
export function Format_formatSpacedNumber(x) {
    return x.toLocaleString("fr", {
        minimumFractionDigits: "0",
        maximumFractionDigits: "2",
        useGrouping: true,
    });
}

/**
 * Format large number values to space-seperated thousands presentation
 */
export function Format_formatSpacedLong(x) {
    return x.toLocaleString("fr", {
        minimumFractionDigits: "0",
        maximumFractionDigits: "2",
        useGrouping: true,
    });
}

export function Format_toShortAmount(x) {
    const x$0027 = ((x < 0) ? (x * -1) : x) | 0;
    if (x$0027 >= 1000000000) {
        const bn = x / 1000000000;
        return `${format('{0:' + "0.#" + '}', bn)} mrd`;
    }
    else if (x$0027 >= 1000000) {
        const mill = x / 1000000;
        return `${format('{0:' + "0.#" + '}', mill)}m`;
    }
    else if (x$0027 >= 1000) {
        const k = x / 1000;
        return `${format('{0:' + "0.#" + '}', k)}k`;
    }
    else {
        return `${x}`;
    }
}

/**
 * Converts a short percentage as whole hundreds to string
 */
export function Format_shortPercentageToString(p) {
    const p_1 = p / 100;
    return format('{0:' + "0.00%" + '}', p_1);
}

export function Format_toShortAmountL(x$0027) {
    const x = (compare(x$0027, 0n) < 0) ? toInt64(op_Multiply(x$0027, -1n)) : x$0027;
    if (compare(x, 1000000000n) >= 0) {
        const bn = toFloat64(x$0027) / 1000000000;
        return `${format('{0:' + "0.##" + '}', bn)} mrd`;
    }
    else if (compare(x, 1000000n) >= 0) {
        const mill = toFloat64(x$0027) / 1000000;
        return `${format('{0:' + "0.##" + '}', mill)}m`;
    }
    else if (compare(x, 1000n) >= 0) {
        const k = toFloat64(x$0027) / 1000;
        return `${format('{0:' + "0.##" + '}', k)}k`;
    }
    else {
        return `${x$0027}`;
    }
}

export function Format_toShortAmountKL(thousands) {
    const x = ((thousands < 0) ? (thousands * -1) : thousands) | 0;
    if (x >= 100000) {
        const bn = thousands / 100000;
        return `${format('{0:' + "0.##" + '}', bn)} mrd`;
    }
    else if (x >= 100) {
        const mill = thousands / 1000;
        return `${format('{0:' + "0.##" + '}', mill)}m`;
    }
    else {
        return `${format('{0:' + "0.##" + '}', thousands)}k`;
    }
}

export function Format_toPositivePercentageChange(old, last) {
    const change = ((100 * old) / last) - 100;
    if (change < 0) {
        return change * -1;
    }
    else {
        return change;
    }
}

export function Format_toPercentageChange(old, last) {
    return ((100 * old) / last) - 100;
}

export function Format_quoteToString(x) {
    return format('{0:' + "0.00" + '}', x);
}

export function Time_toISO8601(dt) {
    return toString(dt, "yyyy-MM-dd HH:mmZ");
}

export function Time_parseAsUtc(dt) {
    return toUniversalTime(parse(dt));
}

export function Time_utcDateToLocalDayAndMonth(x) {
    try {
        return toString(parse(x), "dd/MM");
    }
    catch (matchValue) {
        return x;
    }
}

export function Time_utcStringToLocalTimeSpan(dt) {
    let x_2, x_3, x_4, x_5;
    try {
        const date = parse(dt);
        const matchValue = ~~totalMinutes(op_Subtraction(now(), date)) | 0;
        return (matchValue < 1) ? "Akkurat nå" : ((matchValue < 60) ? (`${matchValue} minutter siden`) : (((x_2 = (matchValue | 0), (x_2 >= 60) && (x_2 < 120))) ? "~1 time siden" : (((x_3 = (matchValue | 0), (x_3 >= 120) && (x_3 < 1440))) ? (`~${~~(matchValue / 60)} timer siden`) : (((x_4 = (matchValue | 0), (x_4 >= 1440) && (x_4 < 2880))) ? "~1 dag siden" : (((x_5 = (matchValue | 0), (x_5 >= 2880) && (x_5 < 4320))) ? (`~${~~(matchValue / (60 * 24))} dager siden`) : toString(date, "dd/MM/yyyy"))))));
    }
    catch (matchValue_1) {
        return "";
    }
}

export function Time_utcStringToTimePeriod(dt) {
    try {
        const days = totalDays(op_Subtraction(parse(dt), now()));
        return (days < -1) ? "" : ((days < 0) ? "~ i dag" : ((days < 2) ? "~ i morgen" : ((days < 7) ? toText(`~${~~days} fra nå`) : ((days < 14) ? "~1 uke fra nå" : ((days < 31) ? (`~${~~(days / 7)} uker fra nå`) : ((days < 45) ? "~1/2 kvartal fra nå" : ((days < 61) ? "~2 måneder fra nå" : ((days < 135) ? "~1 kvartal fra nå" : ((days < 160) ? "~5 måneder fra nå" : ((days < 200) ? "~1/2 år fra nå" : ((days < 240) ? "~7 måneder fra nå" : ((days < 300) ? "~3 kvartal fra nå" : ((days < 400) ? "~1 år fra nå" : (`~${~~(days / 30)} fra nå`))))))))))))));
    }
    catch (matchValue) {
        return "";
    }
}

export function Time_utcStringToLocalDaySpan(dt) {
    try {
        const date = parse(dt);
        const matchValue = totalDays(op_Subtraction(now(), date));
        return (matchValue < 1) ? "I dag" : ((matchValue < 2) ? "I går" : ((matchValue < 5) ? (`${~~matchValue} dager siden`) : toString(date, "dd/MM/yyyy")));
    }
    catch (matchValue_1) {
        return "";
    }
}

export function Time_utcDateToLocalDate(x) {
    try {
        return toString(parse(x), "dd/MM/yyyy");
    }
    catch (matchValue) {
        return x;
    }
}

export function Time_dayOfWeekToString(x) {
    switch (x) {
        case 0:
            return "Søndag";
        case 1:
            return "Mandag";
        case 2:
            return "Tirsdag";
        case 3:
            return "Onsdag";
        case 4:
            return "Torsdag";
        case 5:
            return "Fredag";
        case 6:
            return "Lørdag";
        default:
            return "";
    }
}

export function Time_monthToString(x) {
    switch (x) {
        case 1:
            return "Januar";
        case 2:
            return "Februar";
        case 3:
            return "Mars";
        case 4:
            return "April";
        case 5:
            return "Mai";
        case 6:
            return "Juni";
        case 7:
            return "Juli";
        case 8:
            return "August";
        case 9:
            return "September";
        case 10:
            return "Oktober";
        case 11:
            return "November";
        case 12:
            return "Desember";
        default:
            return "";
    }
}

export function ErrorHandling_checkError(err) {
    let matchResult, x_1;
    if (err.tag === 2) {
        if ((err.fields[0].status) === 401) {
            matchResult = 0;
            x_1 = err.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            window.location.reload();
            break;
        }
        case 1: {
            break;
        }
    }
}

export function Interop_updateInputField(fieldId, newVal) {
    try {
        const entry = window.document.getElementById(fieldId);
        entry.value = newVal;
    }
    catch (matchValue) {
    }
}

export function Interop_updateInputFieldWithOnChange(fieldId, newVal) {
    try {
        const entry = window.document.getElementById(fieldId);
        entry.value = newVal;
        const event = new EventTarget("change");
        entry.dispatchEvent(event);
    }
    catch (matchValue) {
    }
}

export function Interop_tryFocusInput(inputId) {
    try {
        window.document.getElementById(inputId).focus();
    }
    catch (matchValue) {
    }
}

export class Period_PeriodSpan extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Days", "Weeks", "Months", "Quarters", "Years"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? (`${this$.fields[0]} uker`) : ((this$.tag === 2) ? (`${this$.fields[0]} måneder`) : ((this$.tag === 3) ? (`${this$.fields[0]} kvartal`) : ((this$.tag === 4) ? (`${this$.fields[0]} år`) : (`${this$.fields[0]} dager`))));
    }
}

export function Period_PeriodSpan_$reflection() {
    return union_type("Aksjeio.Utils.Period.PeriodSpan", [], Period_PeriodSpan, () => [[["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]]]);
}

export function Period_PeriodSpan__ToValue(this$) {
    switch (this$.tag) {
        case 1:
            return "weeks";
        case 2:
            return "months";
        case 3:
            return "quarters";
        case 4:
            return "years";
        default:
            return "days";
    }
}

export function Period_PeriodSpan_FromValue(x, y) {
    switch (x) {
        case "days":
            return new Period_PeriodSpan(0, [y]);
        case "weeks":
            return new Period_PeriodSpan(1, [y]);
        case "months":
            return new Period_PeriodSpan(2, [y]);
        case "quarters":
            return new Period_PeriodSpan(3, [y]);
        case "years":
            return new Period_PeriodSpan(4, [y]);
        default:
            return undefined;
    }
}

export function Period_PeriodSpan__ToDraft(this$) {
    const patternInput = (this$.tag === 1) ? ["weeks", this$.fields[0]] : ((this$.tag === 2) ? ["months", this$.fields[0]] : ((this$.tag === 3) ? ["quarters", this$.fields[0]] : ((this$.tag === 4) ? ["years", this$.fields[0]] : ["days", this$.fields[0]])));
    return {
        Num: patternInput[1],
        Value: patternInput[0],
    };
}

export function Period_PeriodSpan__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return `for en periode på ${this$.fields[0]} uker`;
        case 2:
            return `for en periode på ${this$.fields[0]} måneder`;
        case 3:
            return `for en periode på ${this$.fields[0]} kvartal`;
        case 4:
            return `for en periode på ${this$.fields[0]} år`;
        default:
            return `for en periode på ${this$.fields[0]} dager`;
    }
}

export function Period_PeriodSpan__ToNumber(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0] | 0;
        case 2:
            return this$.fields[0] | 0;
        case 3:
            return this$.fields[0] | 0;
        case 4:
            return this$.fields[0] | 0;
        default:
            return this$.fields[0] | 0;
    }
}

export function Period_PeriodSpan__Validate(this$) {
    switch (this$.tag) {
        case 1: {
            const x_1 = this$.fields[0] | 0;
            if (x_1 >= 1) {
                return x_1 <= 100;
            }
            else {
                return false;
            }
        }
        case 2: {
            const x_2 = this$.fields[0] | 0;
            if (x_2 >= 1) {
                return x_2 <= 100;
            }
            else {
                return false;
            }
        }
        case 3: {
            const x_3 = this$.fields[0] | 0;
            if (x_3 >= 1) {
                return x_3 <= 40;
            }
            else {
                return false;
            }
        }
        case 4: {
            const x_4 = this$.fields[0] | 0;
            if (x_4 >= 1) {
                return x_4 <= 20;
            }
            else {
                return false;
            }
        }
        default: {
            const x = this$.fields[0] | 0;
            if (x >= 1) {
                return x <= 1000;
            }
            else {
                return false;
            }
        }
    }
}

export function Period_PeriodSpan__ToDateString(this$) {
    switch (this$.tag) {
        case 1:
            return Time_toISO8601(addDays(now(), this$.fields[0] * 7));
        case 2:
            return Time_toISO8601(addMonths(now(), this$.fields[0]));
        case 3:
            return Time_toISO8601(addMonths(now(), this$.fields[0] * 3));
        case 4:
            return Time_toISO8601(addYears(now(), this$.fields[0]));
        default:
            return Time_toISO8601(addDays(now(), this$.fields[0]));
    }
}

export class Period_PeriodType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Span", "ExactDate", "AllTime"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? (`til ${toString(this$.fields[0], "dd/MM/yy")}`) : ((this$.tag === 2) ? "All tid" : toString_1(this$.fields[0]));
    }
}

export function Period_PeriodType_$reflection() {
    return union_type("Aksjeio.Utils.Period.PeriodType", [], Period_PeriodType, () => [[["Item", Period_PeriodSpan_$reflection()]], [["Item", class_type("System.DateTime")]], []]);
}

export function Period_PeriodType__ToDescription(this$) {
    switch (this$.tag) {
        case 0:
            return Period_PeriodSpan__ToDescription(this$.fields[0]);
        case 1:
            return `til ${toString(this$.fields[0], "dd/MM/yy")}`;
        default:
            return "for alltid";
    }
}

export function Period_PeriodType__ToValue(this$) {
    switch (this$.tag) {
        case 1:
            return "date";
        case 2:
            return "alltime";
        default:
            return "span";
    }
}

export function Period_PeriodType__UpdateSpanLength_Z524259A4(this$, x) {
    if (this$.tag === 0) {
        const y = this$.fields[0];
        return new Period_PeriodType(0, [(y.tag === 1) ? (new Period_PeriodSpan(1, [x])) : ((y.tag === 2) ? (new Period_PeriodSpan(2, [x])) : ((y.tag === 3) ? (new Period_PeriodSpan(3, [x])) : ((y.tag === 4) ? (new Period_PeriodSpan(4, [x])) : (new Period_PeriodSpan(0, [x])))))]);
    }
    else {
        return this$;
    }
}

export function Period_PeriodType__IncrementSpanLength(this$) {
    if (this$.tag === 0) {
        const y = this$.fields[0];
        return new Period_PeriodType(0, [(y.tag === 1) ? (new Period_PeriodSpan(1, [y.fields[0] + 1])) : ((y.tag === 2) ? (new Period_PeriodSpan(2, [y.fields[0] + 1])) : ((y.tag === 3) ? (new Period_PeriodSpan(3, [y.fields[0] + 1])) : ((y.tag === 4) ? (new Period_PeriodSpan(4, [y.fields[0] + 1])) : (new Period_PeriodSpan(0, [y.fields[0] + 1])))))]);
    }
    else {
        return this$;
    }
}

export function Period_PeriodType__DecrementSpanLength(this$) {
    let x_1, x_2, x_3, x_4, x;
    if (this$.tag === 0) {
        const y = this$.fields[0];
        return new Period_PeriodType(0, [(y.tag === 1) ? ((x_1 = (y.fields[0] | 0), (x_1 > 1) ? (new Period_PeriodSpan(1, [x_1 - 1])) : (new Period_PeriodSpan(1, [x_1])))) : ((y.tag === 2) ? ((x_2 = (y.fields[0] | 0), (x_2 > 1) ? (new Period_PeriodSpan(2, [x_2 - 1])) : (new Period_PeriodSpan(2, [x_2])))) : ((y.tag === 3) ? ((x_3 = (y.fields[0] | 0), (x_3 > 1) ? (new Period_PeriodSpan(3, [x_3 - 1])) : (new Period_PeriodSpan(3, [x_3])))) : ((y.tag === 4) ? ((x_4 = (y.fields[0] | 0), (x_4 > 1) ? (new Period_PeriodSpan(4, [x_4 - 1])) : (new Period_PeriodSpan(4, [x_4])))) : ((x = (y.fields[0] | 0), (x > 1) ? (new Period_PeriodSpan(0, [x - 1])) : (new Period_PeriodSpan(0, [x])))))))]);
    }
    else {
        return this$;
    }
}

export function Period_PeriodType__SetExactDate_7F9DDECF(this$, x) {
    if (this$.tag === 1) {
        if (compare_1(date_1(x), today()) > 0) {
            return new Period_PeriodType(1, [x]);
        }
        else {
            return this$;
        }
    }
    else {
        return this$;
    }
}

export function Period_PeriodType__Morph_Z721C83C5(this$, x) {
    switch (x) {
        case "days":
            if (this$.tag === 0) {
                return new Period_PeriodType(0, [new Period_PeriodSpan(0, [Period_PeriodSpan__ToNumber(this$.fields[0])])]);
            }
            else {
                return new Period_PeriodType(0, [new Period_PeriodSpan(0, [1])]);
            }
        case "weeks":
            if (this$.tag === 0) {
                return new Period_PeriodType(0, [new Period_PeriodSpan(1, [Period_PeriodSpan__ToNumber(this$.fields[0])])]);
            }
            else {
                return new Period_PeriodType(0, [new Period_PeriodSpan(1, [1])]);
            }
        case "months":
            if (this$.tag === 0) {
                return new Period_PeriodType(0, [new Period_PeriodSpan(2, [Period_PeriodSpan__ToNumber(this$.fields[0])])]);
            }
            else {
                return new Period_PeriodType(0, [new Period_PeriodSpan(2, [1])]);
            }
        case "quarters":
            if (this$.tag === 0) {
                return new Period_PeriodType(0, [new Period_PeriodSpan(3, [Period_PeriodSpan__ToNumber(this$.fields[0])])]);
            }
            else {
                return new Period_PeriodType(0, [new Period_PeriodSpan(3, [1])]);
            }
        case "years":
            if (this$.tag === 0) {
                return new Period_PeriodType(0, [new Period_PeriodSpan(4, [Period_PeriodSpan__ToNumber(this$.fields[0])])]);
            }
            else {
                return new Period_PeriodType(0, [new Period_PeriodSpan(4, [1])]);
            }
        case "exact":
            if (this$.tag === 1) {
                return this$;
            }
            else {
                return new Period_PeriodType(1, [addDays(today(), 1)]);
            }
        default:
            return this$;
    }
}

export function Period_PeriodType__Validate(this$) {
    switch (this$.tag) {
        case 0:
            return Period_PeriodSpan__Validate(this$.fields[0]);
        case 1:
            return compare_1(date_1(this$.fields[0]), date_1(addDays(now(), 1))) >= 0;
        default:
            return true;
    }
}

export function Period_PeriodType__ToPeriodEnd(this$) {
    switch (this$.tag) {
        case 0:
            return Period_PeriodSpan__ToDateString(this$.fields[0]);
        case 1:
            return Time_toISO8601(this$.fields[0]);
        default:
            return "alltime";
    }
}

